import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { formatMonthLabel } from '../helpers/months'

export type MonthLabelFormatter = (monthKey: string | null | undefined) => string | null

/**
 * Turns ISO month keys (`"2026-03"`) into long labels in the current UI
 * language. Reads the language from i18next so labels follow a language switch
 * without a reload, and returns null for a missing month so callers can pass
 * the result straight into optional scope titles.
 */
export const useMonthLabel = (): MonthLabelFormatter => {
  const { i18n } = useTranslation()

  return useCallback((monthKey) => (monthKey ? formatMonthLabel(monthKey, i18n.language) : null), [i18n.language])
}
